var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.founders) ? _c('div', {
    class: [{
      'active': _vm.currentPage == 'founders-content' || _vm.pageIsAutoScrolling
    }, {
      'static': _vm.isAnimated
    }],
    attrs: {
      "id": "founders-content"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__main reduced-width"
  }, [_c('div', {
    staticClass: "content content_founders light-bg"
  }, [_c('div', {
    staticClass: "founders"
  }, _vm._l((_vm.persons.item), function(person) {
    return (person.$is_founder) ? _c('div', {
      staticClass: "founder"
    }, [_c('div', {
      staticClass: "founder__photo",
      style: (("background-image: url(" + (person.background ? person.background.$src : '/f/dist/static/img/noimage.jpg') + ")"))
    }), _vm._v(" "), _c('div', {
      staticClass: "founder__info"
    }, [_c('div', {
      staticClass: "founder__name animated-title",
      class: {
        'animating': _vm.pageReady
      }
    }, [_c('PageTitleContent', {
      class: {
        'static': _vm.isAnimated
      },
      attrs: {
        "isActive": _vm.isActive(),
        "isAnimated": _vm.isAnimated,
        "titleValue": person.text.item.first_name
      }
    }), _c('PageTitleContent', {
      class: {
        'static': _vm.isAnimated
      },
      attrs: {
        "isActive": _vm.isActive(),
        "isAnimated": _vm.isAnimated,
        "titleValue": person.text.item.last_name
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "founder__content",
      domProps: {
        "innerHTML": _vm._s(person.text.item.text_content)
      }
    })])]) : _vm._e()
  }))])])])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-004eb150","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FoundersContent.vue
// module id = 179
// module chunks = 0